/**
 * 日付ユーティリティ
 */

import { format } from 'date-fns'

/**
 * タイムゾーン情報がないISO文字列にZサフィックスを付与してUTCとして扱う
 */
export const ensureUtc = (iso: string): string => {
  if (iso.endsWith('Z') || /[+-]\d{2}:\d{2}$/.test(iso)) return iso
  return iso + 'Z'
}

/**
 * APIから返されるnaive datetime文字列をUTCとして解釈しDateオブジェクトを返す
 */
export const parseUtcDate = (iso: string): Date => new Date(ensureUtc(iso))

/**
 * 2つの日付が同じ日かどうかをチェック
 * 無効な日付の場合はfalseを返す
 */
export const isSameDate = (date1: Date, date2: Date): boolean => {
  if (isNaN(date1.getTime()) || isNaN(date2.getTime())) return false
  return format(date1, 'yyyy-MM-dd') === format(date2, 'yyyy-MM-dd')
}
